/**
 * Programa de referidos: una clínica con plan pagado recibe un código; cuando una clínica nueva que lo usó PAGA su plan,
 * quien la refirió gana días gratis según el plan contratado por el referido (y el referido puede recibir un beneficio).
 * Las reglas (días por plan, topes, espera) viven en la base y las edita el dueño de la plataforma; aquí están los textos.
 */
export type EstadoReferido = "registrado" | "pagado" | "premiado" | "sin_cupo" | "anulado";

export const NOMBRE_ESTADO_REFERIDO: Readonly<Record<EstadoReferido, string>> = {
  registrado: "Registrado (aún no paga)", pagado: "Pagó: premio en espera", premiado: "Premio entregado", sin_cupo: "Sin cupo (tope alcanzado)", anulado: "Anulado",
};

/** Motivos por los que un código no se acepta al crear una clínica. */
export const MOTIVO_REFERIDO: Readonly<Record<string, string>> = {
  codigo_invalido: "El código de referido no existe o quien lo emitió ya no puede referir.",
  propio: "Una clínica no puede usar su propio código.",
  ya_referido: "Esa clínica ya fue referida.",
  no_nueva: "Esa clínica ya había pagado un plan: solo cuentan clínicas nuevas.",
  mismo_titular: "Parece la misma persona o el mismo negocio (mismo RUC, teléfono o administrador).",
};

export const CODIGO_REFERIDO = /^DONNA-[0-9A-F]{6}$/;

/** «7 días» → «1 semana», «14 días» → «2 semanas», «30 días» → «1 mes»… */
export function textoDias(dias: number): string {
  if (dias > 0 && dias % 30 === 0) return dias === 30 ? "1 mes" : `${dias / 30} meses`;
  if (dias > 0 && dias % 7 === 0) return dias === 7 ? "1 semana" : `${dias / 7} semanas`;
  return dias === 1 ? "1 día" : `${dias} días`;
}
